import React from "react"
import links from "../../constants/links"

import styled from "styled-components"
import {
  setColor,
  setShadow,
  setTransition,
  setRem,
  setLetterSpacing,
} from "../../style"
import { useIntl, Link } from "gatsby-plugin-intl"

const Navbar = () => {
  const intl = useIntl()  
  return (
    <Navio>
      <div>
        <ul className="nav-links">
          {links.map((item) => {
            return (
              <li key={item.id} className={item.class}>
                {/* <AniLink paintDrip hex="#f5f5f5" duration={0.5} to={item.path} activeStyle={{ color: "#FFE0E3" }}> */}
                <Link to={item.path}>
                  {intl.formatMessage({id: item.id})}
                  {/* {item.text} */}
                  </Link>
                {/* </AniLink> */}
              </li>
            )
          })}
        </ul>
      </div>
    </Navio>
  )
}

export default Navbar

const Navio = styled.nav`
  padding: 0 1rem;
  background-color: ${setColor.primaryColor};
  ${setShadow.light};

  .nav-links {
    max-width: 992px;
    margin: auto;
    list-style-type: none;
    ${setTransition()};
    height: 0;
    overflow: hidden;
    font-size: ${setRem(14)};
  }
  .nav-links {
    height: auto;
    display: flex;
    justify-content: space-between;
  }

  .nav-links a {
    display: block;
    padding: 5px 10px;
    text-decoration: none;
    text-transform: uppercase;
    color: ${setColor.mainWhite};
    ${setTransition()};
    font-weight: bold;
    letter-spacing: ${setLetterSpacing(1)};
  }
  .nav-links a:hover {
    color: #ffe0e3;
  }
`
